function Loader() {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="justify-content-center jimu-primary-loading"></div>
      </div>
    </div>
  );
}

export default Loader;
